module.exports = __webpack_public_path__ + "img/mastercard-logo.543bc93b.svg";